/**
 * Detect the context where the messaging component is being used
 */
export function detectContext(): 'ambient-intelligence' | 'messaging-app' | 'unknown' {
  // Check if we're in the browser
  if (typeof window === 'undefined') {
    return 'unknown';
  }

  // Check URL patterns
  const pathname = window.location.pathname;

  // Ambient Intelligence contexts
  if (
    pathname.includes('ambient-intelligence') ||
    pathname.includes('website-preview') ||
    pathname.includes('published-site') ||
    pathname.includes('/web/')
  ) {
    return 'ambient-intelligence';
  }

  // Messaging app contexts
  if (pathname.includes('messaging') || pathname.includes('threads') || pathname.includes('chat')) {
    return 'messaging-app';
  }

  // Check for specific DOM markers
  const hasAmbientIntelligence = document.querySelector('[data-ambient-intelligence]');
  if (hasAmbientIntelligence) {
    return 'ambient-intelligence';
  }

  const hasMessagingApp = document.querySelector('[data-messaging-app]');
  if (hasMessagingApp) {
    return 'messaging-app';
  }

  // Check parent components by finding the messaging root element
  const messagingRoot = document.querySelector('.universal-messaging-root');
  if (messagingRoot) {
    const parentWithContext = messagingRoot.closest('[data-theme-context]');
    if (parentWithContext) {
      const context = parentWithContext.getAttribute('data-theme-context');
      if (context === 'ambient-intelligence' || context === 'messaging-app') {
        return context as 'ambient-intelligence' | 'messaging-app';
      }
    }
  }

  return 'unknown';
}

/**
 * Get feature defaults based on context
 */
export function getFeatureDefaults(context: string) {
  switch (context) {
    case 'ambient-intelligence':
      return {
        composer: true,
        threadManagement: false,
        messageActions: true,
        ucManager: true,
        mentions: false,
        reactions: false,
        voiceNotes: false,
      };

    case 'messaging-app':
      return {
        composer: true,
        threadManagement: true,
        messageActions: true,
        ucManager: true,
        mentions: true,
        reactions: true,
        voiceNotes: true,
      };

    default:
      return {
        composer: true,
        threadManagement: true,
        messageActions: true,
        ucManager: true,
        mentions: true,
        reactions: false,
        voiceNotes: false,
      };
  }
}
